import { ReactNode, useState } from 'react';
import { Popover } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import {
  LANGUAGE,
  getItemFromLocalStorage,
  getTokenFromLocalStorage,
  setPendingLanguageToSession,
  removePendingLanguageFromSession
} from 'shared/utils/local-storage';
import { classNames } from 'shared/utils/class-names';
import { changeLanguage } from 'shared/helpers/changeLanguage';
import { useLanguages } from 'shared/utils/hooks/useLanguages';
import { SpanishFlagIcon } from '../Icons';
import UsaFlag from '../Icons/UsaFlag';

import './styles.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getUserSelector, updateUserLanguageData } from 'store/user/user.redux';

const languageIcons: Record<string, ReactNode> = {
  en: <UsaFlag />,
  es: <SpanishFlagIcon />
};

export const SelectLanguage = ({}) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector(getUserSelector);
  const languages = useLanguages();

  const setAppLanguage = (value: string) => {
    const token = getTokenFromLocalStorage();
    changeLanguage(value);
    if (token) {
      removePendingLanguageFromSession();
      dispatch(
        updateUserLanguageData({ userId: user?.id, userLanguage: value })
      );
    } else {
      setPendingLanguageToSession(value);
    }
    setOpen(false);
  };

  if (languages.length < 2) return null;

  return (
    <Popover
      placement="bottom"
      trigger="click"
      open={open}
      onOpenChange={setOpen}
      content={
        <div className={'content'}>
          {languages.map((language) => (
            <button
              key={language.code}
              className={classNames({
                active: language.code === getItemFromLocalStorage(LANGUAGE)
              })}
              onClick={() => setAppLanguage(language.code)}
            >
              {languageIcons[language.code] || <GlobalOutlined />}{' '}
              {language.label}
            </button>
          ))}
        </div>
      }
    >
      <GlobalOutlined className="glob_icon" />
    </Popover>
  );
};
